import * as Styles from './styles';
import Typography from 'Components/common/typography';

export interface IAccordionProps {
    isCurrentStage?: boolean;
    stageCompleted?: boolean;
    boxIndex: number;
    stageData: any;
    //eReqID: string;
    isNextStageClosed?: boolean;
    serviceStatus?: string;
    timestamp?: string;
}

export const StageAccordion = (props: IAccordionProps) => {
    const {
        isCurrentStage,
        stageCompleted,
        boxIndex,
        stageData,
        //eReqID,
        // trackEventParams,
        isNextStageClosed,
        timestamp,
        serviceStatus,
    } = props;

    return (
        <Styles.StageDetailsBox
            isCurrentStage={isCurrentStage}
            stageCompleted={stageCompleted}
            boxIndex={boxIndex}
            isServiceClosed={stageData?.name === 'CLAIM_CLOSED'}
            isNextStageClosed={isNextStageClosed}
            hideArrow={false}
        >
            <Styles.StageTitle
                showLinkArrow={false}
                noStatus={!stageData?.status}
            >
                <div style={{ paddingRight: isCurrentStage ? '77px' : '0' }}>
                    {stageData.title}
                </div>
                {isCurrentStage && (
                    <Styles.ActiveText>{`<- You're here `}</Styles.ActiveText>
                )}
            </Styles.StageTitle>
            <Styles.StageCompletedTime variant="secondary" showInfo={false}>
                {timestamp}
            </Styles.StageCompletedTime>
        </Styles.StageDetailsBox>
    );
};
